import angular from 'angular';

export const ReportsControllerModule = angular
  .module('acme.view.application.reports.controllers', ['acme.common.service.api'])
  .controller('ReportsController', [
    '$scope',
    'ApiService',
    function ReportsController($scope, ApiService) {
      const ctrl = {
        model: {},

        init: function () {
          // Sets the titlebar
          $scope.$emit('Application::contentTitleChange', {
            title: 'Reports',
          });
        },

        success: {
          // Add your success handlers here
          init: function (response) {
            // Handle your response after init
            // Assign your data to the model that you want to operate on
            // This will be reflected directly in your html
            // This can be accessed using {{ reports.model }}
          },
        },

        error: {
          // Add your error handlers here
          init: function (response) {
            // Handle your response after init
            // Assign your data to the model that you want to operate on
            // This will be reflected directly in your html
            // This can be accessed using {{ reports.model }}
          },
        },
      };

      $scope.reports = ctrl;
      ctrl.init();
    },
  ]).name;
